<template>
  <v-navigation-drawer
    v-model="show"
    temporary
    right
    app
    :stateless="stateless"
    :width="computedWidth"
    :style="style"
  >
    <template #prepend>
      <div class="py-4 px-6 d-flex justify-space-between align-center">
        <div class="d-flex align-center flex-grow-1">
          <slot name="customBack" />
          <v-btn
            v-if="(enableBack && isTopDrawer) || $vuetify.breakpoint.mobile"
            icon
            text
            @click="goBack"
          >
            <v-icon>keyboard_backspace</v-icon>
          </v-btn>
          <div class="text-h6 text-truncate d-flex align-center justify-space-between flex-grow-1">
            <div>{{ title }}</div>
            <slot name="headerAppend" />
          </div>
        </div>
      </div>
      <v-divider />
    </template>
    <div
      v-if="loading"
      class="d-flex align-center justify-center h-full"
    >
      <v-progress-circular
        :size="90"
        color="primary"
        indeterminate
      />
    </div>
    <template v-if="(!loading || preloadContent) && show">
      <div
        :class="{ 'pa-5': padded }"
        class="d-flex flex-column"
      >
        <slot />
      </div>
    </template>
    <template #append>
      <PortalTarget :name="`drawerAppend-${id}`">
        <slot name="append" />
      </PortalTarget>
    </template>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'DrawerComponent',

  props: {
    id: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '450'
    },
    preloadContent: Boolean,
    loading: Boolean,
    padded: Boolean
  },

  data() {
    return {
      mobileHeight: 0
    };
  },

  computed: {
    drawer() {
      return this.$store.state.drawers.items.find((x) => x.id === this.id);
    },

    enableBack() {
      return this.$store.getters['drawers/enableBack'];
    },

    isTopDrawer() {
      return this.id === this.$store.getters['drawers/topDrawer'].id;
    },

    computedWidth() {
      if (this.iframed) return '100%';
      return this.width || '450';
    },

    show: {
      get() {
        return this.drawer.open;
      },

      set(val) {
        if (val) {
          if (!this.drawer.open) {
            this.$store.commit('drawers/OPEN_DRAWER', this.id);
          }
        } else {
          this.$store.commit('drawers/CLOSE_DRAWER', this.id);
        }
      }
    },

    stateless() {
      if (this.enableBack && !this.isTopDrawer) return true;
      if (this.$store.getters['config/anyDialogsOpen']) return true;
      return false;
    },

    style() {
      var obj = { 'z-index': this.drawer.zIndex };
      if (this.$vuetify.breakpoint.mobile) {
        obj.height = this.mobileHeight + 'px';
      }
      return obj;
    }
  },

  watch: {
    show(val) {
      if (val && this.$vuetify.breakpoint.mobile) {
        this.mobileHeight = window.innerHeight;
      }
    }
  },

  methods: {
    goBack() {
      this.$store.commit('drawers/GO_BACK');
    },

    close() {
      this.$store.commit('drawers/CLOSE_ALL');
    }
  }
};
</script>

<style></style>
